<div class="header-wrapper border-b border-gray-200" >

  <header>
    <ng-content></ng-content>
  </header>

</div>

